/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_TitleInputs */

const vi_notif_title = /** @type {(inputs: Notif_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo`)
};

/**

* @param {Notif_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_title = /** @type {((inputs?: Notif_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_title(inputs)
});